import { CacheInfoHolder } from "@/helpers/typesDefinition";
import { Activity } from "@26lights/orcha";
import { GET_ACTIVITY } from "@/graphql/orcha/activities/queries";
import { Attachment } from "@26lights/orcha/dist/src/types";

type ActivityResponse = {
  activity: Activity;
};

const ActivityAttachmentsCacheInfoHolder: CacheInfoHolder<
  Attachment,
  ActivityResponse
> = {
  query: GET_ACTIVITY,

  cachedEntitiesToUpdate: (cachedResponse: ActivityResponse): Attachment[] => {
    console.log({ cachedResponse });
    return cachedResponse.activity.attachments ?? [];
  },

  cachedResponse: (
    cachedResponse: ActivityResponse,
    updatedAttachments: Attachment[],
  ): ActivityResponse => ({
    activity: { ...cachedResponse.activity, attachments: updatedAttachments },
  }),

  comparator: () => 1, // New attachment will always be put at the end of the array
};

export default ActivityAttachmentsCacheInfoHolder;
